<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const email = ref('');
const password = ref('');
const errorMessage = ref(null);
const router = useRouter();
const authStore = useAuthStore();

const handleLogin = async () => {
  errorMessage.value = null;
  try {
    await authStore.login(email.value, password.value);
    await router.push('/initializing');
  } catch (error) {
    errorMessage.value = error.message;
  }
};
</script>

<template>
  <Transition name="fade">
    <div class="flex items-center justify-center min-h-screen dark:bg-gray-800 bg-gray-100 px-4">
      <div class="w-full max-w-md p-8 space-y-6 bg-white dark:bg-gray-700 bg-opacity-90 backdrop-filter backdrop-blur-lg rounded-xl shadow-xl mx-auto">
        <img src="/images/electride_app-icon.svg" alt="Logo" class="w-24 mx-auto" />
        <h1 class="text-3xl font-bold text-center text-gray-800 dark:text-gray-500">Login</h1>
        <form @submit.prevent="handleLogin" class="space-y-4">
          <!-- Email Field -->
          <div class="relative">
            <label for="email" class="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
            <input
                v-model="email"
                type="text"
                id="email"
                required
                class="w-full px-4 py-2 border border-gray-300 dark:bg-gray-700 dark:border-gray-400 dark:text-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-700 transition duration-200 ease-in-out"
                placeholder="Insert your email"
            />
          </div>
          <!-- Password Field -->
          <div class="relative">
            <label for="password" class="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">Password</label>
            <input
                v-model="password"
                type="password"
                id="password"
                required
                class="w-full px-4 py-2 border border-gray-300 dark:bg-gray-700 dark:border-gray-400 dark:text-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-700 transition duration-200 ease-in-out"
                placeholder="Insert your password"
            />
          </div>
          <!-- Submit Button -->
          <button
              type="submit"
              class="w-full px-4 py-2 font-semibold text-black bg-emerald-500 rounded-md hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-opacity-50 transition-transform transform hover:scale-105 duration-300 ease-in-out"
          >
            Login
          </button>
          <div class="flex items-center justify-between text-center space-x-1">
            <router-link to="/register" class="text-sm text-emerald-600 dark:text-emerald-200 hover:underline font-semibold" style="font-size: 16px;">
              Create an account
            </router-link>
            <span class="text-sm text-gray-500 font-bold">
              <img src="/images/electride_divider.svg" alt="Or" style="width: 100px;" />
            </span>
            <router-link to="/forgot-password" class="text-sm text-emerald-600 dark:text-emerald-200 hover:underline font-semibold" style="font-size: 16px;">
              Forgot password?
            </router-link>
          </div>
        </form>
        <!-- Error Message -->
        <Transition name="slide-down">
          <p v-if="errorMessage" class="text-sm text-red-600 dark:text-red-400 text-center">{{ errorMessage }}</p>
        </Transition>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
/* Animaciones */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.slide-down-enter-active {
  transition: all 0.5s ease;
}
.slide-down-enter-from {
  transform: translateY(-10px);
  opacity: 0;
}
.slide-down-enter-to {
  transform: translateY(0);
  opacity: 1;
}
</style>
